import { useState } from "react";

export default function useDisclosure() {
  const [show, setShow] = useState(false);

  const onHide = () => {
    setShow(false);
  };

  const onShow = () => {
    setShow(true);
  };

  const onToggle = () => {
    setShow((s) => !s);
  };

  return { show, onHide, onShow, onToggle };
}
